<template>
    <div id="chat-list">
        <supsis-table
            :columns="columns"
            :rows="getData()"
            :bottom-pagination="true"
            :pagination-cursor="paginationCursor"
            @cursor-changed="(cursor) => (paginationCursor = cursor)"
            :options="tableOptions"
            :empty-data-bordered="false"
        >
            <template #header>
                <div style="display: flex; align-items: center; justify-content: space-between">
                    <div></div>
                    <span class="tableSettingsBtn">
                        <a-icon
                            id="tableSettingsButton"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('message.tableSettingTippy')"
                            :style="{ color: '#3699FF' }"
                            data-v-step="12"
                            type="setting"
                            @click="showModal"
                        />
                    </span>
                </div>
            </template>
            <template #emptyData>
                <NoChatFound />
            </template>
        </supsis-table>
        <div
            id="context-menu"
            v-if="selectedItem"
            :style="{ top: contextOpt.top + 'px', left: contextOpt.left + 'px' }"
            @blur="selectedItem = null"
            @mouseleave="selectedItem = null"
        >
            <div class="d-flex flex-column">
                <div
                    class="ctx-btn"
                    v-if="(selectedItem.users || []).length === 0 || fakeMode"
                    id="joinChat"
                    style="margin-left: 0 !important"
                    @click="join(selectedItem)"
                >
                    <span>{{ $t("message.join").toUpperCase() }}</span>
                </div>

                <div
                    class="ctx-btn"
                    v-if="
                        ((selectedItem.users || []).filter((w) => w === user._id).length === 0 &&
                            !observing.includes(selectedItem._id)) ||
                        fakeMode
                    "
                    @click="observe(selectedItem)"
                >
                    <span>{{ $t("message.watch").toUpperCase() }}</span>
                </div>
            </div>
        </div>

        <Modal2
            v-if="isModalShow"
            id="tableColumns"
            :title="$t('message.tableSettings')"
            @cancel="hideModal"
            :show-footer="false"
        >
            <div>{{ $t("message.tableSettingsInfo") }}</div>
            <div class="tableSettings">
                <div v-for="(col, i) in defaultCols" :key="col.key" v-if="col.name !== 'actions'">
                    <div class="item">
                        <b-form-checkbox v-model="tableCols[col.key]" @input="toLocalStorage"
                            >{{ col.title ? col.title : titleEmpty() }}
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
            <div>{{ $t("message.privateParametry") }}</div>
            <div class="tableSettings">
                <div class="item" v-for="col in visitorAttributes" :key="col.name">
                    <b-form-checkbox v-model="tableCols[col.name]" @input="toLocalStorage">
                        {{ col.label }}
                    </b-form-checkbox>
                </div>
            </div>
            <div>{{ $t("message.systemOperetor") }}</div>
            <div class="tableSettings">
                <div class="item" v-for="col in systemOperetor" :key="col.key">
                    <b-form-checkbox
                        v-model="tableCols[col.key]"
                        :disabled="Object.values(tableCols).filter((x) => x === true) && !customLoginFormEnabled"
                        @input="toLocalStorage"
                        >{{ col.title ? col.title : titleEmpty() }}
                    </b-form-checkbox>
                </div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCog, faComment, faCommentAlt, faCommentDots, faEye } from "@fortawesome/free-solid-svg-icons";
import PassedTimeCounter from "./PassedTimeCounter";
import PassedTimeCounterTimeFormat from "./PassedTimeCounterTimeFormat";
import CommentDots from "./svg/CommentDots";
import Info from "./svg/Info";
import Cog from "./svg/Cog";
import * as _ from "lodash";
import { log2 } from "../utils/log2";
import { fakeConversation } from "../utils/utils";
import Information from "./svg/Information";
import Actions from "./svg/Actions";
import Block from "./svg/Block";
import OpenChat from "./svg/OpenChat";
import PrivateMessageIcon from "./svg/PrivateMessageIcon";
import WatchIcon from "./svg/WatchIcon";
import Pagination from "./Pagination";
import { i18n } from "../language";
import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import { filter, map } from "rxjs/operators";
import moment from "moment";
import { getPersistenceData, setPersistenceData } from "../utils/persistenceStorage";
import TelegramIcon from "../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon";
import NoChatFound from "./NoChatFound.vue";
import Modal2 from "../components/common/Modal2.vue";
import WhatsappIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import MessengerIcon from "../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import InstagramIcon from "../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";

import SupsisTable from "./SupsisTable.vue";
import SupsisButton from "../views/Pages/Settings/components/SupsisButton.vue";
import ChatbotIcon from "./svg/ChatbotIcon.vue";
import CalendarPicker from "../views/Pages/Calendar/Component/calendar-events/CalendarPicker.vue";

library.add(faCommentDots, faCog, faEye, faComment, faCommentAlt);

const log = log2("ChatList");
export default {
    name: "ChatList",
    components: {
        CalendarPicker,
        ChatbotIcon,
        SupsisButton,
        SupsisTable,
        MessengerIcon,
        InstagramIcon,
        Actions,
        Information,
        PassedTimeCounter,
        PassedTimeCounterTimeFormat,
        CommentDots,
        Info,
        Cog,
        Pagination,
        Block,
        PrivateMessageIcon,
        OpenChat,
        WatchIcon,
        TelegramIcon,
        NoChatFound,
        Modal2,
        WhatsappIcon,
    },
    props: {
        position: String,
        showMyChats: { type: Boolean, default: false },
        showUnassignedChats: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            channel: (state) => state.channel.channels,
            contacts: (state) => state.whatsapp.contacts,
            user: (state) => state.auth.user,
            selectedSubject: (state) => state.subject.selectedSubject,
            site: (state) => state.site.site,
            users: (state) => state.user.users.data,
            isRoot: (state) => state.auth.user.role.isRoot,
            data: (state) => state.chat.conversations.filter((c) => c.isOnline && c.status !== "destroyed"),
            conversations: (state) => state.chat.conversations,
            observing: (state) => state.chat.observing,
            customLoginFormEnabled: (state) => {
                const enabledFlag = state.setting.settings.customLoginFormEnabled;
                const isValid = !!state.customLoginForm.inputs.filter((x) => x.visible).length;
                return enabledFlag && isValid;
            },
            inputs: (state) => state.customLoginForm.inputs,
            subjects: (state) => state.subject.subjects.data,
            fakeMode: (state) => state.app.fakeMode,
            totalChatCount: (state) => state.chat.stats.total,
            settings: (state) => state.setting.settings,
            socketConnected: (state) => state.socketStatus.socket_connected,
            rows: (state) => state.chat.latestRows,
            visitorAttributes: (state) => state.contactProperty.data || [],
        }),
        ...mapGetters({
            findConversationByVisitorId: "chat/findConversationByVisitorId",
            isDarkMode: "user/isDarkMode",
        }),
        columns() {
            let cols = [
                {
                    title: this.$t("message.fullName"),
                    field: "fullname",
                    key: "Fullname",
                    width: 200,
                    sortBy: "",
                    renderBodyCell: ({ row }) => {
                        return row.fullname;
                    },
                },
                {
                    title: this.$t("message.email"),
                    field: "email",
                    key: "Email",
                    width: 200,
                    sortBy: "",
                },
            ];
            log("customLoginFormEnabled info ", {
                inputs: this.inputs,
                customLoginFormEnabled: this.customLoginFormEnabled,
            });
            const contactProperties = (this.visitorAttributes || []).map((c) => c.name);
            if (this.customLoginFormEnabled) {
                cols = [
                    ...cols,
                    ...this.inputs
                        .filter((x) => !["fullname", "email", "label", "whatsappNumber"].includes(x.type))
                        .map((x) => {
                            let a = {
                                title: x.name,
                                field: x._id,
                                key: x._id,
                                width: 140,
                                renderBodyCell: ({ row }) => this.getInputValue(row, x),
                            };
                            if (x.field === "email") a["width"] = "5%";

                            return a;
                        }),
                ];
            } else {
                cols = [...cols];
            }

            cols = [
                ...cols,
                {
                    title: this.$t("message.whatsappNumber"),
                    key: "whatsappNumber",
                    field: "whatsappNumber",
                    width: 140,
                    sortBy: "",
                    renderBodyCell: ({ row }) => {
                        return row.whatsappNumber || "N/A";
                    },
                },
                {
                    title: this.$t("message.date"),
                    field: "createdDate",
                    key: "createdDate",
                    width: 140,
                    sortBy: "asc",
                    renderBodyCell: ({ row }) => {
                        return this.$options.filters.dateShorted(row.createdDate);
                    },
                },
                {
                    title: this.$t("message.chatDuration"),
                    key: "chatDurations",
                    field: "chatDurations",
                    width: 140,
                    sortBy: "",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div>
                                {row.status === "new" && (row.users || []).length === 0 && (
                                    <PassedTimeCounter date={row.createdDate} />
                                )}
                                {row.status === "active" && (row.users || []).length > 0 && (
                                    <PassedTimeCounterTimeFormat date={row.connectedDate} />
                                )}
                            </div>
                        );
                    },
                },
            ];

            this.defaultCols = cols;

            cols = [
                ...cols,
                ...this.visitorAttributes.map((a) => ({
                    title: a.label,
                    key: a.name,
                    field: a.name,
                    width: 140,
                    renderBodyCell: ({ row }) => {
                        return this.getVisitorAttribute(row, a);
                    },
                })),
            ];
            cols = [
                ...cols,
                ...this.systemOperetor,
                {
                    title: this.$t("message.representative"),
                    field: "users",
                    key: "users",
                    width: 160,
                    renderBodyCell: ({ row }) => {
                        const agents = (row.users || [])
                            .filter((o) => "null" !== o || null != o)
                            .map((id) => this.idToName(id))
                            .join(", ");
                        return (
                            <div
                                v-tippy={{
                                    followCursor: true,
                                    placement: "bottom-end",
                                    theme: this.isDarkMode ? "light-border" : "google",
                                }}
                                content={agents}
                            >
                                {(row.users || []).length === 0 && row.status === "lost"
                                    ? this.$t("message.agentDown")
                                    : this.calculateDate(row)
                                    ? this.$t("message.delayChat")
                                    : agents}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("message.transactions"),
                    key: "actions",
                    field: "actions",
                    align: "right",
                    width: 100,
                    fixed: "right",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="d-flex justify-content-end" style="margin-right: -10px !important">
                                {((row.users || []).length === 0 || this.fakeMode) && (
                                    <md-button
                                        id="joinChat"
                                        v-tippy={{
                                            followCursor: true,
                                            placement: "bottom-end",
                                            theme: this.isDarkMode ? "light-border" : "google",
                                        }}
                                        content={this.$t("message.join")}
                                        class="custom-button"
                                        data-v-step="16"
                                        on-click={() => this.join(row)}
                                    >
                                        <a-icon style="font-size: 14px; color: #49c550" theme="filled" type="message" />
                                    </md-button>
                                )}
                                <a-popover placement="bottom" title="" trigger="click">
                                    <template slot="content">
                                        <div class="content">
                                            {(row.users || []).filter((w) => w === this.user._id).length === 0 &&
                                                !this.observing.includes(row._id) && (
                                                    <div class="d-flex flex-row">
                                                        <div class="justify-content-start">
                                                            <watch-icon />
                                                        </div>
                                                        <div
                                                            class="justify-content-end pl-3 popoverFont cursorPointer"
                                                            on-click={() => this.observe(row)}
                                                        >
                                                            {this.$t("message.watch")}
                                                        </div>
                                                    </div>
                                                )}
                                            {(row.users || []).filter((w) => w === this.user._id).length === 0 ? (
                                                <div class="d-flex flex-row mt-3">
                                                    <div class="justify-content-start">
                                                        <open-chat />
                                                    </div>
                                                    <div
                                                        class="justify-content-end pl-3 popoverFont cursorPointer"
                                                        on-click={() => this.join(row)}
                                                    >
                                                        {this.$t("message.join")}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div class="d-flex flex-row">
                                                    <div class="justify-content-start">
                                                        <open-chat />
                                                    </div>
                                                    <div
                                                        class="justify-content-end pl-3 popoverFont cursorPointer"
                                                        on-click={() => this.join(row)}
                                                    >
                                                        {this.$t("message.open")}
                                                    </div>
                                                </div>
                                            )}
                                            <div class="d-flex flex-row mt-3">
                                                <div class="justify-content-start">
                                                    <private-message-icon />
                                                </div>
                                                {(this.isRoot ||
                                                    this.user.role.permissions
                                                        .map((x) => x.name)
                                                        .includes("visitor.block")) && (
                                                    <div
                                                        class="justify-content-end pl-3 popoverFont cursorPointer"
                                                        on-click={() => this.pm(row._id)}
                                                    >
                                                        {this.$t("message.directMessage")}
                                                    </div>
                                                )}
                                            </div>
                                            <div class="d-flex flex-row mt-3">
                                                <div class="justify-content-start">
                                                    <block />
                                                </div>
                                                {(this.isRoot ||
                                                    this.user.role.permissions
                                                        .map((x) => x.name)
                                                        .includes("visitor.block")) && (
                                                    <div
                                                        class="justify-content-end pl-3 popoverFont cursorPointer"
                                                        on-click={() => this.ban(row._id)}
                                                    >
                                                        {this.$t("message.block")}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </template>
                                    <md-button class="custom-button" data-v-step="15">
                                        <Actions></Actions>
                                    </md-button>
                                </a-popover>
                                <a-popover title="" trigger="click">
                                    <template slot="content">
                                        <div class="px-2">
                                            <b-row class="mb-3">
                                                <b-col md="6" style="color: #9ba2b6; font-weight: bold">
                                                    {this.$t("message.country")}:
                                                </b-col>
                                                <b-col md="6">
                                                    {row.geoLocation ? row.geoLocation.country : "N/A"}
                                                </b-col>
                                            </b-row>
                                            {this.$_.get(row, "geoLocation.city", false) && (
                                                <b-row v-if="" class="mb-3">
                                                    <b-col md="6" style="color: #9ba2b6; font-weight: bold">
                                                        {this.$t("message.city")}:
                                                    </b-col>
                                                    <b-col md="6">{row.geoLocation.city}</b-col>
                                                </b-row>
                                            )}
                                            <b-row class="mb-3">
                                                <b-col md="6" style="color: #9ba2b6; font-weight: bold">
                                                    {this.$t("message.browser")}:
                                                </b-col>
                                                <b-col md="6">
                                                    {row.visitor.browser
                                                        ? row.visitor.browser
                                                        : this.getUserAgentInfo(row.userAgent, "browser")}
                                                </b-col>
                                            </b-row>
                                            <b-row class="mb-3">
                                                <b-col md="6" style="color: #9ba2b6; font-weight: bold">
                                                    {this.$t("message.os")}:
                                                </b-col>
                                                <b-col md="6">
                                                    {row.visitor.os
                                                        ? row.visitor.os
                                                        : this.getUserAgentInfo(row.userAgent, "os")}
                                                </b-col>
                                            </b-row>
                                            <b-row class="mb-3">
                                                <b-col md="6" style="color: #9ba2b6; font-weight: bold">
                                                    {this.$t("message.visitStart")}:
                                                </b-col>
                                                <b-col md="6">{this.$options.filters.date(row.createdDate)}</b-col>
                                            </b-row>
                                        </div>
                                    </template>
                                    <md-button class="custom-button" data-v-step="14">
                                        <Information></Information>
                                    </md-button>
                                </a-popover>

                                {((row.users || []).filter((w) => w === this.user._id).length === 0 &&
                                    !this.observing.includes(row._id)) ||
                                    (this.fakeMode && (
                                        <md-button
                                            v-tippy={{
                                                followCursor: true,
                                                placement: "bottom-end",
                                                theme: isDarkMode ? "light-border" : "google",
                                            }}
                                            content={this.$t("message.watch")}
                                            class="custom-button"
                                            data-v-step="13"
                                            on-click={() => this.observe(row)}
                                        >
                                            <a-icon style="font-size: 14px; color: #49c550" theme="filled" type="eye" />
                                        </md-button>
                                    ))}
                            </div>
                        );
                    },
                },
            ];

            //If there is no table setting in localstorage set default showed tables in chat list

            this.tableCols =
                this.tableCols ||
                cols.reduce((acc, curr) => {
                    if (
                        [
                            "Fullname",
                            "Email",
                            "createddate",
                            "chatdurations",
                            "users",
                            "actions",
                            "whatsapNumber",
                        ].includes(curr.key)
                    ) {
                        acc[curr.key] = true;
                    } else {
                        acc[curr.key] = false;
                    }

                    return acc;
                }, {});

            cols = [
                {
                    title: "",
                    field: "_id",
                    key: "_id",
                    fixed: "left",
                    width: 40,
                    renderBodyCell: ({ row }) => {
                        const renderChatIcon = () => {
                            const whatsappIcon = !!row.whatsappNumber && (
                                <md-icon
                                    style={{ color: "green", fontSize: "18px" }}
                                    v-tippy={{
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: this.isDarkMode ? "light-border" : "google",
                                    }}
                                    content="'Whatsapp Ziyaretçisi'"
                                >
                                    <WhatsappIcon color="green" />
                                </md-icon>
                            );
                            const instagramIcon = !!row.instagramUserId && (
                                <InstagramIcon
                                    special-background-mode
                                    style="width: 24px; height: 24px"
                                    type="instagram"
                                    v-tippy={{
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: this.isDarkMode ? "light-border" : "google",
                                    }}
                                    content={"Instagram Ziyaretçisi"}
                                />
                            );

                            const messengerIcon = !!row.messengerUserId && (
                                <MessengerIcon
                                    style="width: 24px; height: 24px"
                                    v-tippy={{
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: this.isDarkMode ? "light-border" : "google",
                                    }}
                                    content={"Messenger Ziyaretçisi"}
                                />
                            );

                            const telegramIcon = !!row.telegramUserId && (
                                <TelegramIcon
                                    style="width: 24px; height: 24px"
                                    v-tippy={{
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: this.isDarkMode ? "light-border" : "google",
                                    }}
                                    content={"Telegram Bot Ziyaretçisi"}
                                />
                            );
                            const webVisitor = (
                                <md-icon
                                    style={{ color: "#14b9ec", fontSize: "18px" }}
                                    v-tippy={{
                                        followCursor: true,
                                        placement: "bottom-end",
                                        theme: this.isDarkMode ? "light-border" : "google",
                                    }}
                                    content={"Web Ziyaretçisi"}
                                >
                                    ads_click
                                </md-icon>
                            );
                            return whatsappIcon || instagramIcon || messengerIcon || telegramIcon || webVisitor;
                        };
                        return renderChatIcon();
                    },
                },
                ...cols.filter((x) => this.tableCols[x.key]),
            ];

            return cols;
        },
        channelMap() {
            return this.channel.reduce((map, channel) => {
                map[channel._id] = channel.name;
                return map;
            }, {});
        },
    },
    data() {
        return {
            isModalShow: false,
            beep: Audio,
            activeModalActions: null,
            activeModalInfo: null,
            currentSort: {
                columnKey: "createdDate",
                order: "ascend",
            },
            defaultCols: [],
            tableCols: getPersistenceData("chatListCols") ? JSON.parse(getPersistenceData("chatListCols")) : null,
            loading: false,
            dataFetcherSubscriber: null,
            timerId: null,
            lastDataFetchTS: Date.now(),
            selectedItem: null,
            tss: 1,
            contextOpt: {
                top: 0,
                left: 0,
            },
            systemOperetor: [
                {
                    title: this.$t("message.ipAddress"),
                    field: "ipAddress",
                    key: "ipAddress",
                    width: 140,
                    sortBy: "",
                },
                {
                    title: this.$t("message.distWeb"),
                    field: "visitor.visitingPage",
                    key: "visitor.visitingPage",
                    width: 140,
                    sortBy: "",
                    renderBodyCell: ({ row }) => {
                        return row.visitor.visitingPage;
                    },
                },
                {
                    title: this.$t("message.lastLoginPlatform"),
                    field: "visitor.platform",
                    key: "visitor.platform",
                    width: 140,
                    sortBy: "",
                    renderBodyCell: ({ row }) => {
                        return row.visitor.platform;
                    },
                },
                {
                    title: this.$t("message.browser"),
                    field: "visitor.browser",
                    key: "visitor.browser",
                    width: 140,
                    sortBy: "",
                    renderBodyCell: ({ row }) => {
                        return row.visitor.browser;
                    },
                },
                {
                    title: this.$t("whatsappChannel.channelName"),
                    field: "visitor.channel",
                    key: "visitor.channel",
                    width: 140,
                    sortBy: "",
                    renderBodyCell: ({ row }) => {
                        return this.renderChannel(row.channel) || "N/A";
                    },
                },
            ],
            paginationCursor: {
                page: 1,
                perPage: !isNaN(getPersistenceData("chat-page-size") || "undefined")
                    ? parseInt(getPersistenceData("chat-page-size"))
                    : 10,
                total: 0,
            },
            tableOptions: {
                sortOption: {
                    sortChange: (params) => {
                        const sorted = Object.keys(params).find((p) => params[p] !== "");
                        log("tableChange", {});
                        const newSort = {
                            columnKey: sorted,
                            order: params[sorted],
                        };
                        const oldSort = this.currentSort;
                        log("show me current Sort", {
                            currentSort: this.currentSort,
                            newSort,
                        });
                        if (!_.isEqual(newSort, oldSort)) {
                            this.currentSort = newSort;
                            this.$forceUpdate();
                            this.fetchPagedData();
                        }
                    },
                },
                rowStyleOption: {
                    stripe: true,
                },
                "border-x": true,
                "border-y": true,
                rowKeyFieldName: "_id",
                class: "chat-list-table",
                scrollWidth: "1000px",
                virtualScrollOptions: { itemSize: 50, height: 500 },
                cellStyleOption: {
                    bodyCellClass: ({ row, column, rowIndex }) => {
                        const isAgentDown = (row.users || []).length === 0 && row.status === "lost";
                        const isDelayedChat = this.calculateDate(row);
                        return column.key === "users"
                            ? isAgentDown
                                ? "agent-down"
                                : isDelayedChat
                                ? "delayed-chat"
                                : ""
                            : "";
                    },
                },
                eventCustomOption: {
                    bodyCellEvents: () => {
                        return {
                            dblclick: (event) => {
                                let text = event.toElement.innerText;
                                let textArea = document.createElement("textarea");
                                textArea.value = text;
                                document.body.appendChild(textArea);
                                textArea.select();
                                document.execCommand("copy");
                                document.body.removeChild(textArea);
                                this.$message.success({
                                    content: this.$t("message.copiedClipboard"),
                                    duration: 2,
                                    key: "saved",
                                });
                            },
                        };
                    },
                },
            },
        };
    },
    mounted() {
        log.debug("observing", {
            observing: this.observing,
            items: this.data,
            conversations: this.conversations,
        });
        this.dataFetcherSubscriber = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "live_conversations_response"),
                map((x) => x.data)
            )
            .subscribe((data) => {
                const { conversations, total } = data;
                this.loading = false;
                this.paginationCursor.total = total;
                this.setLatestRows(conversations);
                this.tss += 1;
            });
        this.fetchPagedData();
        this.timerId = setInterval(this.fetchPagedData, 2000);
    },
    beforeDestroy() {
        if (this.dataFetcherSubscriber) this.dataFetcherSubscriber.unsubscribe();
        if (this.timerId) clearInterval(this.timerId);
    },
    updated() {},
    methods: {
        ...mapActions({
            joinConversation: "chat/joinConversation",
            banConversation: "chat/banConversation",
            addConversation: "chat/addConversation",
            updateConversation: "chat/updateConversation",
            removeConversation: "chat/removeConversation",
            setPrivateMessageConversation: "chat/setPrivateMessageConversation",
            multiBeepConversation: "chat/multiBeepConversation",
            getSettings: "setting/getSettings",
            viewFakeConversation: "chat/viewFakeConversation",
            setLatestRows: "chat/setLatestRows",
        }),
        showModal() {
            this.isModalShow = true;
        },
        hideModal() {
            this.isModalShow = false;
        },

        calculateDate(data) {
            const isValidStatus = !["lost", "chatbot"].includes(data.status);
            if (isValidStatus && (data.users || []).length === 0) {
                return moment().diff(moment(data.createdDate), "second") > this.settings.overdueTime;
            }
        },
        idToName(userId) {
            const maybeUser = this.users.find((x) => x._id === userId);
            return maybeUser ? maybeUser.name : "";
        },
        fetchPagedData: _.debounce(function () {
            const tookTime = Date.now() - this.lastDataFetchTS;
            if (this.loading && !this.socketConnected && tookTime <= 5000) return;
            this.loading = true;
            this.lastDataFetchTS = Date.now();
            sendSocketMessage("user get-live-conversations", {
                page: this.paginationCursor.page - 1,
                perPage: this.paginationCursor.perPage,
                sortCol: this.currentSort.columnKey,
                sortDirection: this.currentSort.order || "desc",
                userId: this.user._id,
                siteId: this.site._id,
                showMyChats: this.showMyChats,
                showUnassignedChats: this.showMyChats ? this.showUnassignedChats : false,
                selectedSubject: this.selectedSubject,
            });
        }, 1000),
        getSubjectName(id) {
            let maybeSubject = this.subjects.find((x) => x._id == id);
            return maybeSubject ? maybeSubject.languageContent[i18n.locale].name : undefined;
        },
        getInputValue(data, input) {
            log("getInputValue", { data, input });
            let maybeInput = (data.customLoginInfos || []).find((x) => x.input === input._id);
            if (maybeInput) {
                let inputSchema = this.inputs.find((x) => x._id === input._id);
                if (inputSchema.type === "subject") {
                    return this.getSubjectName(maybeInput.value);
                }
                return maybeInput.value;
            }

            if (input.type === "email") {
                return data.email || "N/A";
            }
            if (input.type === "fullname") {
                return data.fullname || "N/A";
            }
            return "-";
        },
        getVisitorAttribute(data, property) {
            const contactProperties = data?.visitor?.contactProperties || [];
            const contactProperty = contactProperties.find((c) => c.property._id === property._id);
            return !contactProperty ||
                (typeof contactProperty.value === "string" && contactProperty.value.trim().length === 0)
                ? "N/A"
                : contactProperty.value;
        },
        titleEmpty() {
            return this.customLoginFormEnabled ? this.inputs[0].localizedLabel[this.$i18n.locale].text : "-";
        },
        getData() {
            if (this.fakeMode) return [fakeConversation()];
            else return this.rows;
        },
        observe(conversation) {
            this.joinConversation({ conversation, observe: true });
        },
        ban(id) {
            this.$dialog
                .confirm(this.$t("message.blockUserConfirm"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    this.banConversation(id);
                });
        },
        pm(id) {
            this.setPrivateMessageConversation(id);
        },
        join(conversation, minimized = false, autoAssign = false) {
            if (this.fakeMode) {
                this.viewFakeConversation(fakeConversation());
                return;
            }
            this.multiBeepConversation([conversation._id]);
            this.joinConversation({
                conversation,
                observe: false,
                minimized: minimized,
                autoAssign: autoAssign,
                sendToSocket: true,
            });
        },
        toLocalStorage() {
            setPersistenceData("chatListCols", JSON.stringify(this.tableCols), true);
        },
        getUserAgentInfo(userAgent, info) {
            const parser = require("ua-parser-js");
            const ua = parser(userAgent || "-");
            if (info === "os") {
                return `${ua.os.name} ${ua.os.version}`;
            } else if (info === "browser") {
                return `${ua.browser.name} ${ua.browser.major}`;
            }
        },
        customRow(r) {
            return {
                on: {
                    contextmenu: (e) => {
                        e.preventDefault();
                        this.selectedItem = r;
                        this.contextOpt = {
                            top: e.y - 120 < 0 ? 0 : e.y - 120,
                            left: e.x - 120,
                        };
                    },
                },
            };
        },
        openVisitorScreen() {
            const isProduction = process.env.ENVIRONMENT === "production";
            const isStage = process.env.ENVIRONMENT === "stage";
            const siteAlias = (this.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
            const protocol = isProduction || isStage ? "https" : "http";
            const hostname = isProduction
                ? "demo-site.supsis.live?customer=" + siteAlias
                : isStage
                ? `demo-site.supsis.live?url=${protocol}://${
                      this.site.customerClientAddress || "betavisitor.supsis.live"
                  }/static/js/loader.js`
                : "localsite.supsis.live?customer=local";
            const url = `${protocol}://${hostname}`;
            window.open(url, "_blank");
        },
        renderChannel(channelId) {
            return this.channelMap[channelId] || "N/A";
        },
    },
    watch: {
        paginationCursor: {
            deep: true,
            handler(newVal, oldVal) {
                newVal = { page: newVal.page, perPage: newVal.perPage };
                oldVal = { page: oldVal.page, perPage: oldVal.perPage };
                localStorage.setItem("chat-page-size", String(newVal.perPage));
                if (!_.isEqual(newVal, oldVal)) {
                    this.fetchPagedData();
                }
            },
        },
        totalChatCount(newValue, oldValue) {
            if (newValue) {
                const total = newValue.length;
                const maxPage = Math.ceil(total / this.paginationCursor.perPage);
                if (this.paginationCursor.page > maxPage) {
                    this.paginationCursor.page = 0;
                } else {
                    if (this.rows.length < this.paginationCursor.perPage) {
                        this.fetchPagedData();
                    }
                }
                if (total < this.paginationCursor.perPage) {
                    this.fetchPagedData();
                }
            }
        },
        showMyChats(newValue) {
            if (newValue) {
                this.fetchPagedData();
            }
        },
        showUnassignedChats(newValue) {
            if (newValue) {
                this.fetchPagedData();
            }
        },
    },
};
</script>

<style lang="scss">
#chat-list {
    padding: 10px;
    height: 100%;

    .supsis-table {
        tr {
            height: max-content !important;
        }

        td {
            padding: 1px 5px !important;
        }

        .delayed-chat {
            background: #a581bc !important;
            color: white;
        }

        .agent-down {
            background: #faaaf0 !important;
        }

        .supsis-table-empty-data {
            height: calc(100vh - 240px);
        }

        .custom-button {
            max-width: 18px;
            min-width: 18px;
            max-height: 18px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .fullname-row {
        .md-icon {
            margin: unset !important;
        }
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        padding: 2px;
        width: max-content;

        .supsis-button {
            border: none !important;
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 4px;

            &.ghost {
                .material-icons {
                    color: black;
                }

                svg {
                    g {
                        path {
                            stroke: black;
                        }
                    }
                }
            }

            svg {
                width: 20px;
            }
        }

        #context-menu {
            position: absolute;
            background-color: #fff;
            box-shadow: 0 0 3px #000;
            top: 0;
            left: 0;
            margin: 0.7rem;
            padding: 0.6rem;
            border-radius: 0.3rem;

            .ctx-btn {
                cursor: pointer;
                border-radius: 3px;
                padding: 4px;

                &:hover {
                    background-color: #0b6473;
                    color: #fff;
                }
            }
        }

        .modal-actions {
            &.active {
                &:before,
                .content {
                    display: block;
                    z-index: 99999;
                }

                .trigger {
                    z-index: 8;
                }
            }

            &:before,
            .content {
                display: none;
            }

            &:before {
                content: "";
                position: fixed;
                top: 0;
                right: 0;
                bottom: -100px;
                left: 0;
                background-color: rgba(0, 0, 0, 0.4);
                z-index: 2;
            }

            .trigger {
                position: relative;
            }

            .content {
                width: 350px;
                left: -10px;
                top: 22px;
                z-index: 3;

                .btn {
                    text-align: left;
                    border-radius: 0;
                    height: 40px;
                    font-size: 18px;
                }

                &:before {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    content: "";
                    background-color: #ffffff;
                    z-index: 1;
                }
            }
        }
    }
}
</style>
